import { WalletAddressStatusName } from "@lib/components/MiniComponents/Others";
import { createYupSync } from "@lib/helpers/TableHelper";
import { walletAddressSchema as yupSchema } from "@lib/schemas/wallet";
import { WalletAddressStatus } from "@lib/types/Billing";
import { Form, Select, Switch } from "antd";
import { FormInstance } from "antd/lib";
import { useEffect } from "react";
import useIntl from "react-intl/lib/src/components/useIntl";

type Props = {
  form: FormInstance<any>;
  loading: boolean;
  walletAddressId?: string;
};

export default function WalletAddressStatusInput(props: Props) {
  const { loading, form, walletAddressId } = props;
  const { messages } = useIntl();
  const walletId = Form.useWatch("walletId", form);
  const status = Form.useWatch("status", form);
  const customerId = Form.useWatch("customerId", form);

  useEffect(() => {
    if (!form) return;
    if (!customerId) {
      form.setFieldValue("status", WalletAddressStatus.Disabled);
    } else {
      form.setFieldValue("status", WalletAddressStatus.InUse);
    }
  }, [customerId, form]);

  return (
    <>
      <Form.Item
        name="status"
        rules={[createYupSync({ schema: yupSchema })]}
        label={messages["common.walletAddressStatus"] as string}
      >
        <Select
          allowClear
          disabled={loading || !walletId}
          variant={
            status === WalletAddressStatus.InUse ? "borderless" : "outlined"
          }
          showSearch
          optionFilterProp="text"
          options={Object.values(WalletAddressStatus)
            .filter((status) =>
              customerId
                ? status !== WalletAddressStatus.Available
                : status !== WalletAddressStatus.InUse,
            )
            .map((status) => ({
              label: <WalletAddressStatusName status={status} />,
              text:
                (messages["enums.walletAddressStatus"][status] as string) ||
                status,
              value: status,
            }))}
        />
      </Form.Item>

      {status === WalletAddressStatus.InUse && walletAddressId && (
        <Form.Item
          name="disabled"
          label={messages["common.walletAddressUsagePermission"] as string}
          rules={[{ required: true }]}
        >
          <Switch
            checkedChildren={messages["common.enabled"] as string}
            unCheckedChildren={messages["common.disabled"] as string}
            defaultChecked
          />
        </Form.Item>
      )}
    </>
  );
}
